import React, { useState } from "react";
import SmartTextArea from "./SmartTextArea";
import HttpEditorPro from "./HttpEditorPro";

export default function FormFilling() {
    const [dynamicFields, setDynamicFields] = useState([
        { name: "", persianName: "", type: "string", description: "", value: "" },
    ]);
    const [status, setStatus] = useState("active");
    const [mainFields, setMainFields] = useState({
        toolName: "",
        toolDescription: "",
    });
    const [url, setUrl] = useState("");

    const handleDynamicChange = (index, field, value) => {
        const newFields = [...dynamicFields];
        newFields[index][field] = value;
        setDynamicFields(newFields);
    };

    const addDynamicField = () => {
        setDynamicFields([...dynamicFields, { name: "", persianName: "", type: "string", description: "", value: "" ,required:false}]);
    };
    const removeDynamicField = (index) => {
        const updated = dynamicFields.filter((_, i) => i !== index);
        setDynamicFields(updated);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = {
            mainFields,
            status,
            dynamicFields,
            url,
        };
        alert("اطلاعات با موفقیت ثبت شد!");
    };

    return (
        <div className="max-w-4xl p-8  shadow-lg rounded-xl border border-gray-200 2xl:mx-auto xl:ml-64">
            <form onSubmit={handleSubmit} className="space-y-8">
                {/* بخش اول */}
                <div className="">
                    <h2 className="text-lg font-semibold  pb-2">اطلاعات ابزار</h2>
                    <div className="grid grid-cols-1  lg:grid-cols-3 gap-10  border border-gray-200 rounded-lg p-4 bg-[#caeddf] justify-between">
                        <div className="">
                            <label className="block mb-1 font-medium text-gray-700">نام ابزار</label>
                            <div className="flex justify-center items-center w-full max-w-xl mx-auto">
                                <input
                                    type="text"
                                    className="w-full mx-auto border border-gray-300 rounded-md p-2  focus:outline-none
                                    focus:ring-2 focus:ring-[#aadec5]    focus:border-2 focus:border-[#aadec5]"
                                    value={mainFields.toolName}
                                    onChange={(e) => setMainFields({ ...mainFields, toolName: e.target.value })}
                                />
                            </div>
                        </div>
                        <div>
                            <label className="block mb-1 font-medium text-gray-700">درباره ابزار</label>
                            {/* <textarea
                                className="border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                                rows={1}
                                value={mainFields.toolDescription}
                                onChange={(e) =>
                                    setMainFields({ ...mainFields, toolDescription: e.target.value })
                                }
                            ></textarea> */}
                            <SmartTextArea onChangeValue={(val) =>
                                setMainFields({ ...mainFields, toolDescription: val })
                            } />
                        </div>
                        {/* <div>
                            <label className="block mb-1 font-medium text-gray-700">وضعیت ابزار</label>
                            <div className="flex gap-6">
                                <label className="flex items-center gap-2">
                                    <input
                                        type="radio"
                                        name="status"
                                        value="active"
                                        checked={status === "active"}
                                        onChange={(e) => setStatus(e.target.value)}
                                    />
                                    فعال
                                </label>
                                <label className="flex items-center gap-2">
                                    <input
                                        type="radio"
                                        name="status"
                                        value="inactive"
                                        checked={status === "inactive"}
                                        onChange={(e) => setStatus(e.target.value)}
                                    />
                                    غیر فعال
                                </label>
                            </div>
                        </div> */}
                        <div className="flex items-center gap-3  lg:mt-5">
                            <div
                                className={`relative inline-flex items-center h-6 w-10 flex-shrink-0 cursor-pointer rounded-full transition-colors duration-200 ease-in-out
                               ${status === "active" ? "bg-[#213e39]" : "bg-gray-300"}`}
                                onClick={() => setStatus(status === "active" ? "inactive" : "active")}
                            >
                                <span
                                    className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out
                                  ${status === "active" ? "-translate-x-5" : "translate-x-0"}`}
                                />
                            </div>
                            <span className="font-medium text-gray-700">{status === "active" ? "فعال" : "غیر فعال"}</span>
                        </div>

                    </div>
                </div>

                <hr className="border-gray-300" />

                {/* بخش دوم */}
                {/* <div className="space-y-4 ">
          <h2 className="text-lg font-semibold border-b pb-2">فیلدهای ابزار</h2>
          {dynamicFields.map((field, index) => (
            <div
              key={index}
              className="grid grid-cols-1 md:grid-cols-3 gap-4 py-5 px-16 items-end border-b border-gray-200 pb-4 mb-4 last:border-b-0 last:mb-0"
            >
              <div>
                <label className="block mb-1 font-medium text-gray-700">نام فیلد</label>
                <input
                  type="text"
                  className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                  value={field.name}
                  onChange={(e) => handleDynamicChange(index, "name", e.target.value)}
                />
              </div>
              <div>
                <label className="block mb-1 font-medium text-gray-700">نوع فیلد</label>
                <select
                  className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                  value={field.type}
                  onChange={(e) => handleDynamicChange(index, "type", e.target.value)}
                >
                  <option value="boolean">Boolean</option>
                  <option value="string">string</option>
                  <option value="number">number</option>
                </select>
              </div>
              <div>
                <label className="block mb-1 font-medium text-gray-700">توضیحات فیلد</label>
                <textarea
                  className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                  rows={3}
                  value={field.description}
                  onChange={(e) => handleDynamicChange(index, "description", e.target.value)}
                ></textarea>
              </div>
            </div>
          ))}
          <button
            type="button"
            onClick={addDynamicField}
            className="flex items-center gap-2 text-blue-600 hover:text-blue-800 font-medium"
          >
            <span className="text-2xl">+</span> افزودن فیلد جدید
          </button>
        </div> */}
                <div className="space-y-4">
                    <h2 className="text-lg font-semibold  pb-2">متغیرهای ابزار</h2>
                    {dynamicFields.map((field, index) => (
                        <div
                            key={index}
                            className="relative grid grid-cols-1 lg:grid-cols-2 gap-10 items-end border border-gray-200 rounded-lg p-4 bg-[#caeddf] "
                        >
                            {index > 0 && (
                                <button
                                    type="button"
                                    onClick={() => removeDynamicField(index)}
                                    className="absolute -top-3 -right-3 bg-[#ffcf4a] hover:bg-[#ffb14a] text-white rounded-full w-7 h-7 flex items-center justify-center text-lg font-bold shadow-md transition-all duration-150"
                                    title="حذف فیلد"
                                >
                                    –
                                </button>
                            )}
                            <div>
                                <label className="block mb-1 font-medium text-gray-700">نام متغیر به فارسی</label>
                                <input
                                    type="text"
                                    className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-[#FFC505]"
                                    value={field.persianName}
                                    onChange={(e) => handleDynamicChange(index, "persianName", e.target.value)}
                                />
                            </div>
                            <div>
                                <label className="block mb-1 font-medium text-gray-700">نام متغیر به انگلیسی</label>
                                <input
                                    type="text"
                                    className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-[#FFC505]"
                                    value={field.name}
                                    onChange={(e) => handleDynamicChange(index, "name", e.target.value)}
                                />
                            </div>
                            <div>
                                <label className="block mb-1 font-medium text-gray-700">نوع متغیر</label>
                                <select
                                    className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-[#FFC505]"
                                    value={field.type}
                                    onChange={(e) => handleDynamicChange(index, "type", e.target.value)}
                                >
                                    <option value="boolean">boolean</option>
                                    <option value="string">string</option>
                                    <option value="number">number</option>
                                    <option value="float">float</option>
                                </select>
                            </div>
                            <div className="mt-2">
                            <label className="block mb-1 font-medium text-gray-700">مقدار پیش فرض متغیر</label>

                                {field.type === "string" && (
                                    <input
                                        type="text"
                                        className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-[#FFC505]"
                                        // placeholder="متن وارد کنید"
                                        value={field.value || ""}
                                        onChange={(e) => handleDynamicChange(index, "value", e.target.value)}
                                    />
                                )}

                                {field.type === "number" && (
                                    <input
                                        type="number"
                                        step="1"
                                        className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-[#FFC505]"
                                        placeholder="عدد صحیح وارد کنید"
                                        value={field.value || ""}
                                        onChange={(e) => handleDynamicChange(index, "value", e.target.value)}
                                    />
                                )}

                                {field.type === "float" && (
                                    <input
                                        type="number"
                                        step="any"
                                        className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-[#FFC505]"
                                        placeholder="عدد اعشاری وارد کنید"
                                        value={field.value || ""}
                                        onChange={(e) => handleDynamicChange(index, "value", e.target.value)}
                                    />
                                )}

                                {/* {field.type === "boolean" && (
                                    <label className="flex items-center gap-2 mt-1">
                                        <input
                                            type="checkbox"
                                            checked={field.value || false}
                                            onChange={(e) => handleDynamicChange(index, "value", e.target.checked)}
                                            className="w-5 h-5 rounded-full accent-blue-500"
                                        />
                                        <span>فعال</span>
                                    </label>
                                )} */}
                                {field.type === "boolean" && (
                                    <div className="flex items-center gap-3 mt-2">
                                        <div
                                            className={`relative inline-flex items-center h-6 w-10 flex-shrink-0 cursor-pointer rounded-full transition-colors duration-200 ease-in-out
                                             ${field.value ? "bg-[#213e39]" : "bg-gray-300"}`}
                                            onClick={() => handleDynamicChange(index, "value", !field.value)}
                                        >
                                            <span
                                                className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out
                                                   ${field.value ? "-translate-x-5" : "translate-x-0"}`}
                                            />
                                        </div>
                                        <span className="font-medium text-[16px] text-gray-700">{field.value ? "true" : "false"}</span>
                                    </div>
                                )}

                            </div>
                            {/* <div>
                                <label className="block mb-1 font-medium text-gray-700">توضیحات فیلد</label>
                                <textarea
                                    className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                                    rows={3}
                                    value={field.description}
                                    onChange={(e) => handleDynamicChange(index, "description", e.target.value)}
                                ></textarea>
                            </div> */}
                            <div>
                                <label className="block mb-1 font-medium text-gray-700">توضیحات متغیر</label>
                                <SmartTextArea
                                    placeholder="توضیحات متغیر را وارد کنید."
                                    maxLength={500}
                                    maxHeight={200}
                                    onChangeValue={(val) => handleDynamicChange(index, "description", val)}
                                />
                            </div>
                            <div className="flex items-center gap-3 mt-2">
                                <div
                                    className={`relative inline-flex items-center h-6 w-10 flex-shrink-0 cursor-pointer rounded-full transition-colors duration-200 ease-in-out
                                   ${field.required ? "bg-[#213e39]" : "bg-gray-300/40"}`} // رنگ خاکستری کم‌رنگ وقتی false
                                    onClick={() => handleDynamicChange(index, "required", !field.required)}
                                >
                                    <span
                                        className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out
                                    ${field.required ? "-translate-x-5" : "translate-x-0"}`}
                                    />
                                </div>
                                <span
                                    className={`font-medium transition-colors duration-200 ${field.required ? "text-gray-700" : "text-gray-400"
                                        }`}
                                >
                                    الزامی است
                                </span>
                            </div>


                        </div>
                    ))}

                    <button
                        type="button"
                        onClick={addDynamicField}
                        className="flex items-center gap-2 text-[#1b4747] hover:text-[#348989] font-medium"
                    >
                        <span className="text-2xl">+</span> افزودن فیلد جدید
                    </button>
                </div>
                <hr className="border-gray-300" />

                {/* بخش سوم */}
                <div className="space-y-4">
                    <h2 className="text-lg font-semibold  pb-2">آدرس URL</h2>
                    <div className="py-5  border border-gray-200 rounded-lg p-4 bg-[#caeddf]">
                        <label className="block mb-1 font-medium text-gray-700"> URL ابزار </label>
                        {/* <input
                            type="text"
                            className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                            value={url}
                            onChange={(e) => setUrl(e.target.value)}
                        /> */}
                          <HttpEditorPro value={url} onChange={setUrl} placeholder="http:{…}" />
                          <p className="text-gray-600 mt-6 text-[16px] ml-2" style={{direction:"ltr"}}>  URL: {url}</p>
                    </div>
                    
                </div>

                <button
                    type="submit"
                    className="w-full bg-[#1b4747] hover:bg-[#338787] text-white font-semibold py-3 rounded-lg shadow-md transition-all duration-200"
                >
                    ثبت
                </button>
            </form>
        </div>
    );
}
